import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=714bd229&"
import script from "@/model/setpassword?vue&type=script&lang=js&"
export * from "@/model/setpassword?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports